import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useDisplaysComponentsManager } from '@panneau/core/contexts';

var styles = {};

var _excluded = ["value", "display", "className"];
var propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any,
  display: PropTypes.string,
  className: PropTypes.string
};
var defaultProps = {
  value: null,
  display: null,
  className: null
};
var DisplayField = function DisplayField(_ref) {
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? null : _ref$value,
    _ref$display = _ref.display,
    display = _ref$display === void 0 ? null : _ref$display,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var displays = useDisplaysComponentsManager();
  var Component = displays.getComponent(display) || null;
  return value !== null && Component !== null ? /*#__PURE__*/React.createElement(Component, Object.assign({
    className: classNames([styles.container, _defineProperty({}, className, className !== null)])
  }, props, {
    value: value
  })) : null;
};
DisplayField.propTypes = propTypes;
DisplayField.defaultProps = defaultProps;

var definition = {
  id: 'display',
  component: 'Display'
};

export { DisplayField as default, definition };
